<template>
    <div>
        <router-view :isMobile="isMobile" />
    </div>
</template>

<script>
export default {
    props: {
        isMobile: Boolean
    }
};
</script>

<style lang="scss" scoped>
</style>